import camelCase from "camelcase";
import mapObject from "map-obj";

/**
 * Deeply camelCase the keys of parsed JSON. Keys matching `exclude` are kept
 * as they are, but their values are still converted.
 *
 * A letter after a digit keeps its case, so `credits_earned_30d` becomes
 * `creditsEarned30d` rather than `creditsEarned30D`.
 */
export const camelizeKeys = <T>(data: T, exclude: RegExp[]): T => {
  if (Array.isArray(data)) {
    return data.map((item) => camelizeKeys(item, exclude)) as T;
  }
  if (data === null || typeof data !== "object") {
    return data;
  }
  return mapObject(
    data as Record<string, unknown>,
    (key, value) => [
      exclude.some((pattern) => pattern.test(key))
        ? key
        : camelCase(key, { locale: false, capitalizeAfterNumber: false }),
      value,
    ],
    { deep: true },
  ) as T;
};
